/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocioConfiguracion } from '../../conexiones';
import IFiltrosPisos from './entidades/filtrosPisos';
import IPisos from './entidades/pisos';

export default class ModeloPisos {
    public consultarPisos() {
        return manejadorRest<IRespuesta<IPisos>>(() => negocioConfiguracion.get('Piso/ConsultarListaPiso'), true);
    }
    public crearPisos(pisos: IPisos) {
        return manejadorRest<IRespuesta<IPisos>>(() => negocioConfiguracion.post('Piso/GuardarPiso', pisos), true);
    }
    public editarPisos(pisos: IPisos) {
        return manejadorRest<IRespuesta<IPisos>>(() => negocioConfiguracion.put('Piso/EditarPiso', pisos), true);
    }
    public eliminarPisos(pisos: IPisos) {
        return manejadorRest<IRespuesta<IPisos>>(() => negocioConfiguracion.delete('Piso/EliminarPiso', pisos), true);
    }
    public consultarListaPisosPorFiltro(filtrosPisos: Partial<IPisos>) {
        return manejadorRest<IRespuesta<IPisos>>(
            () => negocioConfiguracion.post('Piso/ConsultarListaPisoPorFiltro', filtrosPisos),
            true
        );
    }
}
